import { getFileExtension, removeFileExtension } from '@com/utils/file'
import { Base64 } from 'js-base64'
import { generateUUID, getBinName, parseBinContent } from '@ps/utils/game'
import { AssetType } from '@ps/utils/config'
import assets from '@ps/bridge/qc/assets'

// bin文件名字有特定要求
export const isLegalName = (name: string) => {
  // 只有一个.、.bin结尾且不仅仅只有.bin
  return (
    name.indexOf('.bin') > 0 &&
    name.indexOf('.') === name.lastIndexOf('.') &&
    name.indexOf('.bin') === name.length - 4
  )
}

export const convertLegalName = (name: string): string => {
  return removeFileExtension(name).replace(/\./g, '_') + '.bin'
}

/**
 * 从 files 数组里获取 bin uuid
 * @param files bin 文件的 files 属性
 * @param binFileName bin 文件名字
 */
export const getBinUuidFromFiles = ({
  files,
  binFileName,
}: {
  files: {
    name: string
    data: string
  }[]
  binFileName: string
}) => {
  let binUUID = ''
  // 用bin文件的uuid作为名字的md5特性重命名
  files.forEach((item) => {
    if (item.name === binFileName) {
      const binContent = Base64.decode(item.data)
      const binContentObj = parseBinContent(binContent)
      binUUID = binContentObj.uuid
    }
  })
  return binUUID
}
export type ImageBinMeta = {
  uuid: string
  type: number
  source: string[]
}

/**
 * 生成图片 bin 内容
 * @param name 图片名字，如 test.png
 */
export function cookImageBinContent({
  name,
  resourcePath,
}: {
  name: string
  resourcePath: string
}): {
  // 如 test.bin
  binName: string
  binContent: string
  uuid: string
} {
  const binName = getBinName(name)
  // 文件名后缀必须是小写，不然无法使用该资源
  const ext = getFileExtension(name, false).toLowerCase()
  let uuid = generateUUID()
  // 如果uuid列表已有该路径的bin文件,则不用生成新的uuid
  for (const i in assets.uuid2UrlConf) {
    if (
      typeof assets.uuid2UrlConf[i] !== 'undefined' &&
      assets.uuid2UrlConf[i].indexOf(resourcePath + binName) > -1
    ) {
      uuid = i
      break
    }
  }
  const meta: ImageBinMeta = {
    uuid,
    type: AssetType.ASSET_ATLAS,
    source: ['.' + ext],
  }
  const arr = []
  arr.push(JSON.stringify(meta))
  arr.push(JSON.stringify({}))
  // 图片 bin 文件不需要文件 base64
  arr.push('')
  const binContent = JSON.stringify(arr)
  return { binName, binContent, uuid }
}
